export enum AustrianVRCType {
    DEFAULT, // normal yellow one
    CARD, // 'Scheckkarte'
}
